import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';

import { Header } from './DefaultLayout/components';

export const HeaderLayout: FC = () => {
  return (
    <Flex minH="100vh" flexDir="column" justify="stretch" align="stretch">
      <Header onOpenMenu={undefined} />
      <Outlet />
    </Flex>
  );
};
